
import { mutations } from '@/assets/scripts/store'
import { fetchFood } from '@/assets/scripts/api'
import PageData from '@/mixins/PageData'

export default {
  name: 'FoodPage',

  mixins: [PageData],

  async asyncData() {
    const apiData = await fetchFood()
    return { apiData }
  },

  data() {
    return {
      selectedCategory: 0,
      isVideoPlaying: false,
      stickyEnabled: false,
      storeFilters: [
        { label: 'sur place / à emporter', enabled: true, filter: ({ hasFood }) => hasFood.onSite === true || hasFood.onTakeAway === true },
        { label: 'en livraison', enabled: false, filter: ({ hasFood }) => hasFood.onDelivery === true },
      ],
    }
  },

  computed: {
    navLinks() {
      return this.apiData.products.map((product) => ({ icon: product.icon ? product.icon.origin : null }) )
    },

    galleryPics() {
      return this.apiData.gallery.images.map(image => image.origin ? image.origin.url : null ).filter(image => image !== null)
    },
  },

  mounted() {
    this.stickyNavEl = this.$refs['nav-category-sticky']

    if (this.stickyNavEl) {
      const stickyLayoutEl = document.querySelector('.layout__sticky')
      stickyLayoutEl.appendChild(this.stickyNavEl)
    }

    document.addEventListener('scroll', this.onScroll, { passive: true })
  },

  beforeDestroy() {
    if (this.stickyNavEl) {
      const parentEl = this.stickyNavEl.parentNode
      if (parentEl) parentEl.removeChild(this.stickyNavEl)
    }

    document.removeEventListener('scroll', this.onScroll, { passive: true })
  },

  methods: {
    onCategorySelect(index) {
      const el = this.$refs['nav-category-' + index][0].$el
      if (!el) return

      el.scrollIntoView({ behavior: 'smooth' })
    },

    onGallerySelect(index) {
      mutations.openLightBox(this.galleryPics, index)
    },

    onScroll() {
      const count = this.apiData.products.length
      const limit = window.innerHeight / 2
      let id = null
      let index = -1
      let i = 0

      for (i = 0; i < count; i++) {
        id = 'nav-category-' + i
        if (this.getRefTopPosition(id) > limit) break;
        index = i
      }

      this.stickyEnabled =
        this.getRefTopPosition('nav-category-0') < 0 &&
        this.getRefTopPosition(`nav-category-${count - 1}`) > -limit * 1.5

      this.selectedCategory = index
    },

    getRefTopPosition(id) {
      const el = this.$refs[id][0].$el
      return el ? el.getBoundingClientRect().top : 0
    },

    hasFood({ hasFood }) {
      return hasFood.onSite === true || hasFood.onTakeAway === true || hasFood.onDelivery === true
    },
  }
}
